import fetch from "./fetch";
let HEALTHAPI = process.env.VUE_APP_HEALTH_API;
let BOTAPI = process.env.VUE_APP_HEALTH_API;
let WUYANGAPI = process.env.VUE_APP_WU_YANG_BASE_API;
let MAIDIANAPI = process.env.VUE_APP_MAIDIAN_API;
// 查询日程
export function schedule(params) {
	return fetch({
		url: "/aihealth/schedule/search",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 饮食推荐查询接口
export function recipeRecommend(params) {
	return fetch({
		url: "/diet/recipeRecommend",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 食谱搜索
export function recipeSearch(params) {
	return fetch({
		url: "/diet/recipeSearch",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 饮食记录保存
export function recordSaveOrUpdate(params) {
	return fetch({
		url: "/diet/recordSaveOrUpdate",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 饮食记录查询
export function recordList(params) {
	return fetch({
		url: "/diet/recordList",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 饮食记录评估和建议
export function recipeValuation(params) {
	return fetch({
		url: "/diet/recipeValuation",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 食材查询
export function nutritionDetail(params) {
	return fetch({
		url: "/diet/nutrition_detail",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 血压评估和建议
export function bloodPressureValuation(params) {
	return fetch({
		url: "/vitalSign/bloodPressureValuation",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 用户查询所绑定的设备接口
export function getDevice(params) {
	return fetch({
		url: "/user/getDevice",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}

// 压力算法备注
export function stressInterpretation(params) {
	return fetch({
		url: "/vitalSign/stressInterpretation",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 获取家庭关系v3
export function getFamilyRelationV3(params) {
	return fetch({
		url: "/friend/getFamilyRelationV3",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}

// 添加家庭成员
export function addFamilyMember(params) {
	return fetch({
		url: "/friend/addFamilyMember",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 删除家庭成员
export function delFamilyMember(params) {
	return fetch({
		url: "/friend/delFamilyMember",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 根据多个configkey查询value
export function getConfigList(params) {
	return fetch({
		url: "/config/getConfigList",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 查询家庭成员
export function getFamilyMember(params) {
	return fetch({
		url: "/friend/getFamilyMember",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 编辑家庭成员
export function updateFamilyMember(params) {
	return fetch({
		url: "/friend/updateFamilyMember",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 虚拟节点关联真实用户
export function attachToVirtualNode(params) {
	return fetch({
		url: "/friend/attachToVirtualNode",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}



// 获取阿里云tts语音合成token
export function aliyunTtsToken(params) {
	return fetch({
		url: "/speechAndText/aliyunTtsToken",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
// 创建预约单
export function appointmentOrder(params) {
	return fetch({
		url: "/consultation/create/appointment/order",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 预约单天数查询
export function getAppointmentDay(params) {
	return fetch({
		url: "/consultation/get/appointment/by/days",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 预约单坐诊机构查询
export function getAppointmentOrg(params) {
	return fetch({
		url: "/consultation/get/appointment/by/org",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 预约单时段查询
export function getAppointmentTimes(params) {
	return fetch({
		url: "/consultation/get/appointment/by/times",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 更多推荐医生
export function recommendations(params) {
	return fetch({
		url: "/staff/recommendations",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 查询医生基本信息
export function getDoctorInfo(params) {
	return fetch({
		url: "/consultation/get/doctor/info",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 获取区域列表
export function getAreaList(params) {
	return fetch({
		url: "/dict/getAreaList",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 查询就诊人列表
export function patientList(params) {
	return fetch({
		url: "/patient/patientList",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 就诊人详情
export function patientDetail(params) {
	return fetch({
		url: "/patient/patientDetail",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 删除就诊人
export function delPatient(params) {
	return fetch({
		url: "/patient/delPatient",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 添加/编辑就诊人
export function addOrModifyPatient(params) {
	return fetch({
		url: "/patient/addOrModifyPatient",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 获取项目枚举
export function getEnum(params) {
	return fetch({
		url: "/config/get/enum",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 发送短信验证码
export function sendSmsCode(params) {
	return fetch({
		url: "/auth/sendMateSmsCode",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 我的预约
export function getMyAppointmentOrder(params) {
	return fetch({
		url: "/consultation/my/appointment/order",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 我的预约状态变更
export function appointmentOrderStatus(params) {
	return fetch({
		url: "/consultation/update/status",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// ai会话历史
export function aiRegister(params) {
	return fetch({
		url: "/dialog/conversation/history",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
// 第三方接口转发
export function apiProxy(params) {
	return fetch({
		url: "/api/proxy?url="+params.url,
		contentType:"application/json",
		// baseUrl: "http://10.4.140.201:12345",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}


// c端查看自己的签约状态
export function doctorUserStatus(params) {
	return fetch({
		url: "/user/sign/user/status",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 创建上门申请
export function createHometreat(params) {
	return fetch({
		url: "/home/treat/creater/order",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 家庭医生签约
export function signDoctor(params) {
	return fetch({
		url: "/user/sign/doctor/creater",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 家庭医生解约
export function unSignDoctor(params) {
	return fetch({
		url: "/user/sign/update/status",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

// 家庭医生签约详情
export function getSignDoctorDetail(params) {
	return fetch({
		url: "/user/sign/detail/by/doctor",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
// 查询最新app版本
export function getLatestVersion(params) {
	return fetch({
		url: "/version/getLatestVersion",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}

/*
为患者匹配医生
http://lk-uc-api.danao-pro.laikang.enn.cn/web/#/18/800
 */
export function doctorUserMatch(params) {
	return fetch({
		url: "/staff/match",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/*
血糖智能备注
http://lk-uc-api.danao-pro.laikang.enn.cn/web/#/18/801
 */
export function smartAdvice(params) {
	return fetch({
		url: "/vitalSign/get/smart/advice",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/*
查询我的三剂康养方案
http://lk-uc-api.danao-pro.laikang.enn.cn/web/#/18/880
 */
export function healthPlan(params) {
	return fetch({
		url: "/healthPlan/my",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
/*
康养计划详情接口
http://lk-uc-api.danao-pro.laikang.enn.cn/web/#/18/896
 */
export function healthPlanInfo(params) {
	return fetch({
		url: "/healthPlan/info",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
/*
查询三剂康养方案详情
http://lk-uc-api.danao-pro.laikang.enn.cn/web/#/18/877
 */
export function healthPlanType(params) {
	return fetch({
		url: "/healthPlan/type",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}

/**
 * 查询三大产能数据
 */
export function getRatios(params) {
	return fetch({
		url: "/healthPlan/diet/ratios",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
/**
 * 查询出组报告
 */
export function getLeaveGroupReportList(params) {
	return fetch({
		url: "/leaveGroup/getLeaveGroupReportList",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 * 社区结构查询
 */
export function getTenantList(params) {
	return fetch({
		url: "/tenant/list",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}

/**
 * 社区对应的科室
 * @param {tenantId:1}
 */
export function getTenantDept(params) {
	return fetch({
		url: "/tenant/dept/list",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}

/**
 * 社区对应的医生
 */
export function doctorUserList(params) {
	return fetch({
		url: "/staff/list",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
/**
 * 医生列表	
 */
export function doctorVisitList(params) {
	return fetch({
		url: "/staff/visit/list",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 * 手机验证码校验
 * mobile
 * smsCode
 */
export function checkMateSmsCode(params) {
	return fetch({
		url: "/auth/checkMateSmsCode",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 * 用户注销
 */
export function cancellation(params) {
	return fetch({
		url: "/user/cancellation",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}

/**
 * 是否在个人设置中显示血压-血糖入口
 */
export function showIndicator(params) {
	return fetch({
		url: "/groupMembersAlertDoctors/showIndicator",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 *  用户饮食评估列表
 */
export function nutritionList(params) {
	return fetch({
		url: "/nutrition/list",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 *  查询未读消息数量
 */
export function getUnreadMsgCount(params) {
	return fetch({
		url: "/groupChat/getUnreadMsgCount",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
//获取用户管理群
export function getManageGroupInfo(params) {
	return fetch({
		url: "/groupChat/getManageGroupInfo",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
//绑定面舌诊报告{userId:"",examId:""}
export function bindingReport(params) {
	return fetch({
		url: "/healthScreening/bindingReport",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
/**
 * 获取最新的面舌诊报告结果{"userId":11,"examType":1,"pageNum":1,"pageSize":1}
 * @param {} params.examType  1:面舌诊体质 2:肤诊 3:脉诊
 * @returns 
 */
export function reportList(params) {
	return fetch({
		url: "/healthScreening/reportList",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "post",
		params,
	});
}
//获取舌诊报告内容 examId=123
export function getReportDetailByExamId(params) {
	return fetch({
		url: "/healthScreening/getReportDetailByExamId",
		contentType: "application/json",
		baseUrl: BOTAPI,
		method: "get",
		params,
	});
}
//获取舌诊报告-五养内容 {"pageId":0,"diseaseCode":"TZBSQIXUZ"}
export function interposeApi(params) {
	return fetch({
		url: "/interpose/api",
		baseUrl: WUYANGAPI,
		method: "post",
		params,
	});
}

/**
 * 获取饮食评估详情
 * @param {userID:11,imageUrl:123,msgId:123}	 params userID:用户id imageUrl:图片地址 msgId:消息id
 * @returns 
 */
export function getDietComment(params) {
	return fetch({
		url: "/diet/comment",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}

/**
 * 当天群内发送的饮食图片
 * @param {userId:11} params userID:用户id
 * @param {pageNum:1,pageSize:10} params pageNum:页码 pageSize:每页数量
 * @returns 
 */
export function getDietImageList(params) {
	return fetch({
		url: `/groupImage/diet/list?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}

/**
 * 不是饮食图片
 * @param {id:11} params id:图片记录id
 * @returns 
 */
export function deleteDietImage(params) {
	return fetch({
		url: "/groupImage/update/dietstate",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}

/**
 * 识别餐饮图片
 * @param {id:11} params id:图片记录id
 * @returns 
 */
export function dietImageContent (params) {
	return fetch({
		url: "/diet/image_content",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params,
	});
}
/**
 * 干预计划查询-根据计划Id
 * @param {planId:11} planId:计划id
 * @returns 
 */
export function getInterventionPlan (params) {
	return fetch({
		url: "/interventionPlan/get?planId="+params.planId,
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
	});
}
/**
 * 饮食记录分页查询
 * @param {id:11} id:最后一条记录的ID	
 * @param {userId} 
 * @param {pageSize} 
 * @returns 
 */
export function dietPage (params) {
	return fetch({
		url: "/diet/page?pageSize="+params.pageSize,
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 获取体检问题
 */
export function examinationConfig (params) {
	return fetch({
		url: "/physical/examination/config",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}

/**
 * 体检报告提交
 */
export function examinationReportSubmit (params) {
	return fetch({
		url: "/physical/examination/submit",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 体检报告基础信息
 */
export function examinationReportBasic (params) {
	return fetch({
		url: "/physical/examination/report/basic",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 体检报告--减重计划
 */
export function weightLossPlan (params) {
	return fetch({
		url: "/physical/examination/report/weightLossPlan",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 体检报告--未来风险预测
 */
export function futureRiskPrediction (params) {
	return fetch({
		url: "/physical/examination/report/futureRiskPrediction",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 获取跳转商城链接的参数
 */
export function getLinkParam (params) {
	return fetch({
		url: "/joolun_mall/getLinkParam",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
		params
	});
}
/**
 * 商品浏览
 * @param {spuId:11} params id:商品id
 * @returns 
 */
export function goodsBrowse (params) {
	return fetch({
		url: "/joolun_mall/goodsBrowse",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "post",
		params
	});
}
/**
 * 获取配送订单信息
 */
export function getDeliveryOrderInfo (params) {
	return fetch({
		url: "/joolun_mall/getDeliveryOrderInfo",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
		params
	});
}
/**
 * 获取吉祥物-app主题
 */
export function findMascotByUserId (params) {
	return fetch({
		url: "/mascot/findMascotByUserId",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
		params
	});
}
/**
 * 获取保险链接
 */
export function getActivityLink (params) {
	return fetch({
		url: "/health/activity/link",
		contentType: "application/json",
		baseUrl: HEALTHAPI,
		method: "get",
		params
	});
}
/**
 * 仿真报告列表
 */
export function clientList (params) {
	return fetch({
		url: "/isgateway/lk-simulation/simReport/clientList",
		contentType: "application/json",
		baseUrl: MAIDIANAPI,
		method: "post",
		params
	});
}
/**
 * 是否可以做仿真评估
 */
export function clientIsCanSim (params) {
	return fetch({
		url: "/isgateway/lk-simulation/simReport/clientIsCanSim",
		contentType: "application/json",
		baseUrl: MAIDIANAPI,
		method: "post",
		params
	});
}

